import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';

import DeleteIcon from '@material-ui/icons/Delete';

import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';

import {BUTTON_TYPES} from '../../../constants/dialogButtonTypes';

class DialogButton extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.getElements = this.getElements.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            open: false,
            promise: null
        };
    }

    getElements() {
        const contentAction = this.props.type === BUTTON_TYPES.ARCHIVE.key && this.props.data.isArchived ? 'restore' : this.props.type;
        const contentName = <em>{this.props.data[this.props.nameKey]}</em> || 'this item';

        return {
            content: <span>
                <FormattedMessage id="common.confirmMessage"/>
                <FormattedMessage id={`buttons.${contentAction}`}>
                    {text => `${text.toLowerCase()} `}
                </FormattedMessage>
                "{contentName}"?
            </span>,
            icon: do {
                if (this.props.type === BUTTON_TYPES.ARCHIVE.key) {
                    this.props.data.isArchived ? <UnarchiveIcon/> : <ArchiveIcon/>;
                } else if (this.props.type === BUTTON_TYPES.DELETE.key) {
                    <DeleteIcon/>;
                }
            }
        };
    }

    handleClose(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({open: false});
    }

    handleOpen(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({open: true});
    }

    handleSubmit(e) {
        e.persist();
        this.props.onSubmit(this.props.data);
        this.handleClose(e);
    }

    render() {
        const elements = this.getElements();
        const submitClasses = classNames({
            submitting: this.props.isSubmitting
        });

        return (
            <IconButton
                disabled={this.props.disabled}
                disableTouchRipple={true}
                onClick={this.state.open ? null : this.handleOpen}
            >
                {elements.icon}
                <Dialog open={this.state.open} onClose={this.handleClose}>
                    <DialogTitle>
                        {this.props.title}
                    </DialogTitle>
                    <DialogContent>
                        <div className="side-padding">
                            {elements.content}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button className={submitClasses} onClick={this.handleSubmit}>
                            <FormattedMessage id={`buttons.confirm`}/>
                        </Button>
                        <Button className={submitClasses} onClick={this.handleClose}>
                            <FormattedMessage id="buttons.cancel"/>
                        </Button>
                    </DialogActions>
                </Dialog>
            </IconButton>
        );
    }
}

DialogButton.propTypes = {
    data: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    nameKey: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    onSubmit: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]).isRequired,
    type: PropTypes.oneOf([BUTTON_TYPES.ARCHIVE.key, BUTTON_TYPES.DELETE.key]).isRequired
};

export default DialogButton;


// WEBPACK FOOTER //
// ./src/components/common/button/DialogButton.js